<template>
  <div>
    <div class="sticky-top">
      <div class="card m-b-0">
        <div class="card-body text-right m-r-30">
          <span v-if="edit">
            <a href @click.prevent="deleteTopic()" class="btn btn-warning m-r-10">
              <i class="fa fa-trash"></i>
              Supprimer
            </a>
            <a href @click.prevent="saveTopic()" class="btn btn-primary m-r-10">
              <i class="fa fa-save"></i>
              Enregistrer
            </a>
            <a href @click.prevent="setEdit(false)" class="btn btn-outline m-r-10">
              <i class="fa fa-times"></i>
            </a>
          </span>
          <span v-else>
            <a href @click.prevent="setEdit(true)" class="btn btn-outline m-r-10">
              <i class="fa fa-pencil"></i>
            </a>
          </span>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="container-fluid">
        <transition name="fade" mode="out-in">
          <div v-loading="loading">
            <div class="row">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-header">
                    <h2 class="h3" :class="{'text-muted': !topic.title}">
                      <span v-if="topic.rich_title" v-html="topic.rich_title"></span>
                      <span v-else>{{ topic.title || 'Aucun titre' }}</span>
                      <br />
                      <small>
                        {{ topic.slug }}
                        <br />
                        Création le {{ topic.created_at | formatDate }}
                        - Dernière mise à jour le
                        {{ topic.updated_at | formatDate('DD-MM-YYYY à HH:mm') }}
                      </small>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <el-tabs type="border-card" class="m-b-30">
              <el-tab-pane label="Attributs">
                <div class="m-t-10">
                  <div v-if="!edit" class="row">
                    <div class="col-md-6">
                      <dl class="row">
                        <dt class="col-sm-4 m-b-30 text-right text-muted">Statut</dt>
                        <dd class="col-sm-8">{{ $t(`topic.${topic.status}`) }}</dd>
                      </dl>
                    </div>
                    <div class="col-md-6">
                      <dl class="row">
                        <dt class="col-sm-4 m-b-30 text-right text-muted">Publication le</dt>
                        <dd class="col-sm-8">
                          <span
                            v-if="topic.published_at"
                          >{{ topic.published_at | formatDate('DD-MM-YYYY à HH:mm')}}</span>
                          <span v-else class="text-muted">Non précisé</span>
                        </dd>
                      </dl>
                    </div>
                  </div>
                  <div v-if="edit" class="row">
                    <div class="col-md-12">
                      <el-form label-position="right" size="medium" label-width="120px">
                        <el-form-item label="Titre">
                          <el-input
                            autosize
                            @input="updateTopicAttribute('title', $event)"
                            :value="topic.title"
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="Chapô">
                          <el-input
                            type="textarea"
                            :autosize="{ minRows: 3, maxRows: 6}"
                            @input="updateTopicAttribute('headline', $event)"
                            :value="topic.headline"
                          ></el-input>
                        </el-form-item>
                        <div class="row">
                          <div class="col-md-6">
                            <el-form-item label="Statut">
                              <el-select
                                @change="updateTopicAttribute('status', $event)"
                                :value="topic.status"
                              >
                                <el-option
                                  v-for="item in constants.TOPIC_STATUSES"
                                  :label="$t(`topic.${item}`)"
                                  :key="item"
                                  :value="item"
                                >{{ $t(`topic.${item}`) }}</el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="Publication">
                              <el-date-picker
                                v-model="topic_published_at"
                                @change="updateTopicPublishedAt"
                                type="datetime"
                                format="dd-MM-yyyy HH:mm"
                                placeholder="Choississez un jour"
                              ></el-date-picker>
                            </el-form-item>
                          </div>
                        </div>
                      </el-form>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
            <div class="row">
              <div class="col-md-8">
                <el-tabs type="border-card" class="m-b-30">
                  <el-tab-pane label="Chapô">
                    <p>{{ topic.headline }}</p>
                  </el-tab-pane>
                </el-tabs>
                <el-tabs type="border-card" class="m-b-30">
                  <el-tab-pane label="Contenu">
                    <topic-stories :edit="edit" :mask="mask" />
                  </el-tab-pane>
                </el-tabs>
              </div>
              <div class="col-md-4">
                <el-tabs type="border-card" class="m-b-30">
                  <el-tab-pane label="Illustration">
                    <div>
                      <el-image
                        style="width: 100%; height: 100%;"
                        :src="topic.cover_image_url"
                        :preview-src-list="[topic.cover_image_url]"
                        fit="contain"
                      ></el-image>
                    </div>
                    <div v-if="edit" class="m-b-20">
                      <div class="row">
                        <div class="col-md-6">
                          <el-upload
                            :show-file-list="false"
                            :action="`topics/${$route.params.id}/upload-cover/` | api_url"
                            :http-request="uploadCover"
                          >
                            <el-button size="small" type="primary">
                              <i class="fa fa-upload"></i>
                              Choisir
                            </el-button>
                          </el-upload>
                        </div>
                        <!-- <div class="col-md-6 text-right">
                          <router-link
                            v-if="topic.cover_image_url"
                            tag="span"
                            class="m-l-10"
                            :to="{name: 'topic_thumbnails', params: {id: topic.id}}"
                          >
                            <el-button size="small" type="info">
                              <i class="fa fa-crop"></i>
                              Modifier
                            </el-button>
                          </router-link>
                        </div>-->
                      </div>
                    </div>
                    <el-form v-if="edit" label-position="top" size="medium">
                      <el-form-item>
                        <el-input
                          placeholder="Crédits photo"
                          @input="updateTopicAttribute('cover_image_credits', $event)"
                          :value="topic.cover_image_credits"
                        ></el-input>
                      </el-form-item>
                    </el-form>
                    <p v-else class="text-right">
                      <small>{{ topic.cover_image_credits }}</small>
                    </p>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: mapGetters({
    constants: "constants",
    topic: "topic"
  }),
  data() {
    return {
      edit: false,
      loading: false,
      mask:
        "id, title, rich_title, slug, created_at, updated_at, published_at, status," +
        "headline, cover_image_credits, cover_image, cover_image_url," +
        "stories {id, status, thumb_story_list_url, title, primary_category, published_at}",
      topic_published_at: null
    };
  },
  created() {
    this.init();
  },
  watch: {
    $route(to, from) {
      this.edit = JSON.parse(to.query.edit);
      this.init();
    }
  },
  methods: {
    init() {
      this.loading = true;
      if (this.$route.query.edit) {
        this.edit = this.$route.query.edit;
      }
      this.$store.dispatch("getConstants", {
        params: { keys: "TOPIC_STATUSES" }
      });
      this.$store
        .dispatch("getTopic", {
          id: this.$route.params.id,
          headers: {
            "X-Fields": this.mask
          }
        })
        .then(() => {
          this.topic_published_at = JSON.parse(
            JSON.stringify(this.topic.published_at)
          );
          this.loading = false;
        });
    },
    setEdit(edit) {
      this.$router.push({
        name: "topic",
        params: { id: this.$route.params.id },
        query: { edit: edit }
      });
    },
    updateTopicAttribute(key, value) {
      let data = {
        [key]: value
      };
      this.$store.commit("UPDATE_TOPIC_VALUE", data);
    },
    updateTopicPublishedAt(value) {
      this.updateTopicAttribute(
        "published_at",
        new Date(value.getTime() - value.getTimezoneOffset() * 60000)
          .toISOString()
          .replace("Z", "")
      );
    },
    isPublishable() {
      console.log(this.topic.cover_image);
      if (!this.topic.title.length) {
        this.$message({
          type: "error",
          message:
            "Vous devez définir un titre pour pouvoir publier un dossier."
        });
        return false;
      }
      if (!this.topic.headline.length) {
        this.$message({
          type: "error",
          message:
            "Vous devez définir un chapô pour pouvoir publier un dossier."
        });
        return false;
      }
      if (!this.topic.cover_image) {
        this.$message({
          type: "error",
          message:
            "Vous devez ajouter une illustration pour pouvoir publier un dossier."
        });
        return false;
      }
      if (
        this.topic.stories.filter(story => story.status === "PUBLISHED")
          .length < 2
      ) {
        this.$message({
          type: "error",
          message:
            "Vous devez définir au moins 2 contenus publiés pour pouvoir publier un dossier."
        });
        return false;
      }
      return true;
    },
    uploadCover(option) {
      const formData = new FormData();
      formData.append("image", option.file);
      this.$store
        .dispatch("uploadTopicCover", {
          formEncodedData: formData,
          id: this.$route.params.id,
          headers: {
            "X-Fields": this.mask
          }
        })
        .then(() => {
          this.updateTopicAttribute(
            "cover_image_url",
            this.topic.cover_image_url + "?d=" + new Date()
          );
        });
    },
    saveTopic(silent) {
      if (this.topic.status === "PUBLISHED" && this.isPublishable() === false) {
        this.updateTopicAttribute("status", "DISABLED");
        silent = true;
      }
      this.loading = true;
      return this.$store
        .dispatch("saveTopic", {
          headers: {
            "X-Fields": this.mask,
            "X-UpdateKeys":
              "title,status,headline,cover_image_credits,published_at"
          }
        })
        .then(() => {
          this.loading = false;
          if (!silent) {
            this.$message({
              type: "success",
              message: "Enregistrement effectué avec succès"
            });
          }
          this.init();
        });
    },
    deleteTopic() {
      this.$confirm("Ceci effacera le dosser. Continuer ?", "Warning", {
        confirmButtonText: "Supprimer",
        cancelButtonText: "Annuler",
        type: "warning"
      })
        .then(() => {
          this.$store
            .dispatch("deleteTopic", {
              id: this.$route.params.id,
              headers: {
                "X-Fields": this.mask
              }
            })
            .then(() => {
              this.$message({
                type: "success",
                message: "Dossier supprimé"
              });
              this.$router.replace({
                name: "topics"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Suppression annulée"
          });
        });
    }
  }
};
</script>